import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CrystalTripDTO, SynchTripDTO } from 'business/models/Models';
import { CrystalClientDTO } from 'components/Experiment/constants';
import { EHarvestingView } from 'components/Experiment/Harvesting/constants';
import {
  CrystalDataDTO,
  EditStatus,
  SynchTripDataDTO,
} from 'components/synchrotron/constants';

export type SynchTripDataState = {
  harvestingContentView: EHarvestingView;
  crystalsTrips: CrystalTripDTO[];
  selectedTripCrystals: CrystalClientDTO[];
  selectedTripCrystalIds: number[];
  selectedTripId: number;
  allSynchTrips: SynchTripDTO[];
  originalSynchTrip: SynchTripDataDTO;
  editedSynchTrip: SynchTripDataDTO;
  crystalId: number;
  selectedAssignedCrystalIds: number[];
  selectedTripResultIDs: number[];
};

const initialState = {
  harvestingContentView: EHarvestingView.HARVESTING,
  crystalsTrips: [],
  selectedTripCrystals: [],
  selectedTripCrystalIds: [],
  selectedTripId: 0,
  allSynchTrips: [],
  originalSynchTrip: {},
  editedSynchTrip: {},
  crystalId: 0,
  selectedAssignedCrystalIds: [],
  selectedTripResultIDs: [],
} as SynchTripDataState;

const synchrotronTripReducer = createSlice({
  name: 'SynchrotronTrip',
  initialState,
  reducers: {
    setHarvestingContentView: (state, action) => {
      state.harvestingContentView = action.payload;
    },
    setCrystalTrips: (state, action) => {
      state.crystalsTrips = action.payload;
    },
    setSelectedTripsCrystals: (state, action) => {
      state.selectedTripCrystals = action.payload;
    },
    setSelectedTripsCrystalIds: (state, action) => {
      state.selectedTripCrystalIds = action.payload;
    },
    setSelectedTripId: (state, action) => {
      state.selectedTripId = action.payload;
    },
    setallSynchTrips: (state, action) => {
      state.allSynchTrips = action.payload;
    },
    setSynchTripData: (state, action: PayloadAction<SynchTripDataDTO>) => {
      state.originalSynchTrip = action.payload;
      state.editedSynchTrip = action.payload;
    },
    setEditedSynchTripData: (state, action: PayloadAction<SynchTripDataDTO>) => {
      state.editedSynchTrip = { ...state.editedSynchTrip, ...action.payload };
    },
    setSelectedCrystalId: (state, action: PayloadAction<number>) => {
      state.crystalId = action.payload;
    },
    setSelectedCrystal: (state, action: PayloadAction<number>) => {
      state.crystalId = action.payload;
    },
    setAllCrystals: (state, action: PayloadAction<CrystalDataDTO[]>) => {
      state.editedSynchTrip.assignedCrystals = action.payload;
    },
    setTripEditStatus: (state, action: PayloadAction<EditStatus>) => {
      state.editedSynchTrip.editStatus = {
        ...state.editedSynchTrip.editStatus,
        ...action.payload,
      };
    },
    setIsCrystalAssignmentsDirty: (state, action: PayloadAction<boolean>) => {
      state.editedSynchTrip.isCrystalAssignmentsDirty = action.payload;
    },
    setSelectedTripResultIDs: (state, action: PayloadAction<number[]>) => {
      state.selectedTripResultIDs = action.payload;
    },
    setSelectedAssignedCrystalIds: (state, action: PayloadAction<number[]>) => {
      state.selectedAssignedCrystalIds = action.payload;
    },
  },
});

export const {
  setHarvestingContentView,
  setCrystalTrips,
  setSelectedTripsCrystals,
  setSelectedTripsCrystalIds,
  setSelectedTripId,
  setallSynchTrips,
  setSynchTripData,
  setEditedSynchTripData,
  setSelectedCrystalId,
  setSelectedCrystal,
  setAllCrystals,
  setTripEditStatus,
  setIsCrystalAssignmentsDirty,
  setSelectedTripResultIDs,
  setSelectedAssignedCrystalIds,
} = synchrotronTripReducer.actions;

export default synchrotronTripReducer.reducer;
